import React from 'react';

const ColorKey = ({ start, stop, height = '12px', width = '70px' }) => {
  const style = {
    height,
    width,
    borderRadius: '5px',
    background: `linear-gradient(to right, ${start}, ${stop})`
  };

  return <div style={style}>&nbsp;</div>;
};

export default ColorKey;
